import React from "react";
import { motion } from "framer-motion";
import { RiAddLine } from "react-icons/ri";
import "./Fab.css";

const Fab = ({ onClick }) => (
  <motion.button
    type="button"
    className="fab"
    onClick={onClick}
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    whileTap={{ scale: 0.94 }}
    whileHover={{ scale: 1.04 }}
    transition={{ type: "spring", stiffness: 300, damping: 20 }}
    aria-label="Start workout"
  >
    <RiAddLine size={22} />
    <span className="fab-label">Start Workout</span>
  </motion.button>
);

export default Fab;
